module.exports = __webpack_public_path__ + "1.0/img/title-pre-rank.f9baf76c.png";